import { render, staticRenderFns } from "./AppTable.vue?vue&type=template&id=5ca3aee9&scoped=true&"
import script from "./AppTable.vue?vue&type=script&lang=ts&"
export * from "./AppTable.vue?vue&type=script&lang=ts&"
import style0 from "./AppTable.vue?vue&type=style&index=0&id=5ca3aee9&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5ca3aee9",
  null
  
)

export default component.exports